/**
 * Types of export
 * @enum {string}
 * @readonly
 */
const TExportType = {
    /**
     * Type rubric
     * @type {string}
     * @constant
     */
    RUBRICS: 'GTA02',
    /**
     * Type times
     * @type {string}
     * @constant
     */
    TIMES: 'GTA04',
}

export default TExportType
